import { Col, Row } from "antd";
import { useState } from "react";
import Card_ot_permission_group from './Card_ot_permission_group'

const Main = (props) => {
    const language = props.language
    return (<>
        <Row gutter={[24, 24]} wrap>
            <Col>
                <Card_ot_permission_group
                    title_text={null}
                    pages={Object.entries(language.children)}
                />
            </Col>
        </Row>
    </>)
}
export default Main;